import React from "react";
import {connect} from 'react-redux'
import {Link} from "react-router-dom";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

//Icons
import PlaylistAddRounded from "@material-ui/icons/PlaylistAddRounded"; 
import IconButton from '@material-ui/core/IconButton';

import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';

// core components
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";


import Table from "components/Table/Table.jsx";
import LinearProgress from '@material-ui/core/LinearProgress';
import Checkbox from "components/Checkbox/Checkbox";

//Table actions
import Actions from 'views/Tables/Actions'

//Approve popUp
import ConfirmAlert from 'components/Alert/Confirm'
import ProgressAlert from 'components/Alert/Progress'
import SuccessAlert from 'components/Alert/Success'

//Styles
import buttonsStyle from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx";


// Actions
import {
  adjustmentsReasonsFetch,
  adjustmentReasonsRemove,
  adjustmentReasonsFilter,
  approveAdjustmentReasons,
  declineAdjustmentReasons
} from 'actions/adjustmentsReasons'

//import Button from "components/CustomButtons/Button.jsx";

class List extends React.Component {
  selected=[]
  state = {
    selected: []
  }
  componentDidMount(){
    this.filter({sort:{adjustmentReasonId: 'asc'}, size:10})
    //this.props.adjustmentsReasonsFetch();
  }
  //on choose record
  select(id) {
    let select = []
    if (Array.isArray(id)) 
      select = (this.state.selected.length > 0)
        ? []
        : id
    else if (this.state.selected.indexOf(id) > -1) 
      select = this.state.selected.filter((e) => e !== id)
    else 
      select = this
        .state
        .selected
        .concat(id)
    this.setState({
      ...this.state,
      selected: select
    })
  }
  confirmDelete() {
      if(this.selected.length===0){
        this.props.fetch();
        this.setState({
          ...this.state,
          selected:[],
          alert: <SuccessAlert
            title={`Done!`}
            onConfirm={()=>{this.setState({...this.state,alert:false});}}
          />
        });
        return false;
      }
      this.setState({
        ...this.state,
        alert: <ProgressAlert
        value={100-((this.selected.length*100)/this.state.selected.length)}
        title={`Delete Adjustments (${this.state.selected.length-this.selected.length+'/'+this.state.selected.length})`}
        />
      });
      this.props.remove(this.selected[0])
        .then((e)=>{
          this.selected=this.selected.slice(1);
          this.confirmDelete();
        })
  }
  //on choose click delete 
  delete() {
    this.setState({
      ...this.state,
      alert: <ConfirmAlert
        text={`to delete ${this.state.selected.length} adjustmentsReasons \n( ${
          this.state.selected.map(id=>this.props.adjustmentsReasons.list.find(e=>e.adjustmentReasonId===id).name).join(', ')
        } )`}
        onCancel={()=>this.setState({...this.state,alert:false})}
        onConfirm={()=>{
          this.selected=this.state.selected.slice(0);
          this.confirmDelete();
      }}
      />
    });
  }
  //Filter change for pagination or limitation
  filter(filter){
    this.setState({...this.state,selected:[]})
    this.props.filter({
      ...this.props.adjustmentsReasons.pageable,
      ...filter,
      page: filter.size 
        ? 0 
        : filter.page !== undefined ? filter.page : this.props.adjustmentsReasons.pageable.page
    })
    this.props.fetch()
  }
  approveAdjustment(id) {
    //this.props.approveAdjustmentReasons(id)
  }
  declineAdjustment(id) {
    //this.props.declineAdjustmentReasons(id)
  }
 

  render() {
    const {adjustmentsReasons, match} = this.props;
    const selected = this.state.selected
    
    return (
      <Card>
        {this.state.alert}
        {
        (!adjustmentsReasons.isFetching)?
        //Top actions (pgination/limit/add/remove/edit)
        <Actions
          onPagination={(page)=>this.filter({page:page-1})}
          limit={adjustmentsReasons.pageable.size}
          limitOptions={[10,100,200]}
          onLimitation={(page)=>this.filter({size:page})}
          pagination={adjustmentsReasons.pageable.totalPages>1?{
            pages:adjustmentsReasons.pageable.totalPages,
            current:adjustmentsReasons.pageable.page+1,
          }:false}
          // title={this.getTableTitle()}
          dark={selected.length>0}
          icon={<PlaylistAddRounded/>}
          actions={{
            add: (selected.length===0)
            ? <Link to={`${match.path}/add`}>
                <IconButton>
                  <AddIcon/>
                </IconButton>
              </Link>
            : '',
            delete: (selected.length>0) && this.props.permissions.includes('ADJUSTMENTS_DELETE')
              ? <IconButton onClick={this.delete.bind(this)}><DeleteIcon/></IconButton>
              : '',
            edit: (selected.length===1)
              ? ''
              // <Link to={`${match.path}/${this.state.selected[0]}`}>
              //     <IconButton>
              //         <EditIcon/>
              //     </IconButton>
              //   </Link>
              : ''
        }}/>:''}

        <CardBody>
          {/* If is fetching not display table*/}
          {(adjustmentsReasons.isFetching)
            ? <LinearProgress color="primary"/>
            : (
              //Main table
              <Table
                tableHeaderColor="primary"
                sort={adjustmentsReasons.pageable.sort}
                onSort={(e)=>this.filter({sort:{[e]:adjustmentsReasons.pageable.sort[e]==='desc'?'asc':'desc'}}) }
                tableHead={{ 
                    checkbox:<Checkbox props = {{ 
                      onClick:()=>this.select(adjustmentsReasons.list.map(e=>e.adjustmentReasonId)),
                      checked:this.state.selected.length===adjustmentsReasons.list.length}
                    }/>,
                    name: "Name", 
                    description: "Description"
                  }}
                tableData={adjustmentsReasons.list.map((e,i) => [ 
                    <Checkbox props = {{ onClick:()=>this.select(e.adjustmentReasonId), checked:this.state.selected.indexOf(e.adjustmentReasonId)>-1 }}/>, 
                    e.name, 
                    e.description
                  ] )}/>
            )}
        </CardBody>
       { 
         adjustmentsReasons.list.length>20
        ?<Actions
            onPagination={(page)=>this.filter({page:page-1})}
            pagination={adjustmentsReasons.pageable.totalPages>1?{
              pages:adjustmentsReasons.pageable.totalPages,
              current:adjustmentsReasons.pageable.page+1,
            }:false}
        />:''}
      </Card>
    );
  }
}
const mapStateToProps = (state) => ({
  adjustmentsReasons: state.adjustmentsReasons,
  adjustmentReasons: state.adjustmentsReasons.reasonsList,
  permissions: state.auth.permissions
})
const mapDispatchToProps = (dispatch) => ({
  filter: (filter) => dispatch(adjustmentReasonsFilter(filter)),
  fetch: () => dispatch(adjustmentsReasonsFetch()),
  adjustmentsReasonsFetch: () => dispatch(adjustmentsReasonsFetch()),
  remove: (id) => dispatch(adjustmentReasonsRemove(id)),
  approveAdjustmentReasons: (id) => dispatch(approveAdjustmentReasons(id)),
  declineAdjustmentReasons: (id) => dispatch(declineAdjustmentReasons(id))
})
export default withStyles(buttonsStyle)(connect(mapStateToProps, mapDispatchToProps)(List));



// WEBPACK FOOTER //
// ./src/views/AdjustmentsReason/List.jsx